<template>
  <div>

    <label>Select Account Type</label>
    <input type="hidden" :value="selected" name="user[sign_up_role]"/>
    <div class="tw-grid tw-grid-cols-2 tw-gap-3">
      <button class="btn py-3"
              :class="{'btn-primary': selected === option.id, 'btn-outline': selected !== option.id}"
              type="button" v-for="option in options" :key="option.id" @click="selected = option.id">
       <span class="tw-flex tw-flex-col">
         <i :class="option.icon"/>
         <span class="tw-font-medium tw-mt-3">{{ option.title }}</span>
         <span class="tw-text-sm"
               :class="{'tw-text-gray-500': selected !== option.id}">
           {{ option.description }}
         </span>
       </span>
      </button>
    </div>
  </div>
</template>

<script>
export default {

  data: function () {
    return {
      selected: null,
    }
  },

  watch: {
    selected: function (val) {
      this.toggleRoleFields(val)
    }
  },

  mounted() {
    this.toggleRoleFields(this.selected)
  },

  methods: {
    toggleGroupVisibility(fieldRefObj, enabled) {
      if (enabled) {
        document.getElementById(fieldRefObj.group).classList.remove('d-none')
        document.getElementById(fieldRefObj.input).removeAttribute('disabled')
      } else {
        document.getElementById(fieldRefObj.group).classList.add('d-none')
        document.getElementById(fieldRefObj.input).setAttribute('disabled', true)
      }
    },

    toggleRoleFields(selectedVal) {
      if (selectedVal === 'customer') {
        this.toggleGroupVisibility(this.fieldRefIds.companyName, true)
        this.toggleGroupVisibility(this.fieldRefIds.firstName, false)
        this.toggleGroupVisibility(this.fieldRefIds.lastName, false)
      } else if (selectedVal === 'pending_contributor') {
        this.toggleGroupVisibility(this.fieldRefIds.companyName, false)
        this.toggleGroupVisibility(this.fieldRefIds.firstName, true)
        this.toggleGroupVisibility(this.fieldRefIds.lastName, true)
      } else {
        this.toggleGroupVisibility(this.fieldRefIds.companyName, false)
        this.toggleGroupVisibility(this.fieldRefIds.firstName, false)
        this.toggleGroupVisibility(this.fieldRefIds.lastName, false)
      }
    }
  },

  computed: {

    fieldRefIds() {
      return {
        companyName: {
          group: 'sign-up-company-name-field',
          input: 'user_company_name'
        },
        firstName: {
          group: 'sign-up-first-name-field',
          input: 'user_first_name'
        },
        lastName: {
          group: 'sign-up-last-name-field',
          input: 'user_last_name'
        }
      }
    },

    options() {
      return [
        {
          id: "customer",
          title: "Customer Account",
          description: "Download royalty-free stock content for your creative projects",
          icon: "fas fa-user-plus fa-2x"
        },
        {
          id: "pending_contributor",
          title: "Contributor Account",
          description: "Upload and sell your photos, videos, and illustrations",
          icon: "fas fa-camera fa-2x"
        }
      ]
    }
  }
}
</script>
